import Vue from 'vue';
import AMapLoader from '@amap/amap-jsapi-loader';

interface Options {
  key: string; // 申请好的Web端开发者Key，首次调用 load 时必填
  version?: string; // 指定要加载的 JSAPI 的版本，缺省时默认为 2.0
  plugins?: string[]; // 插件列表
  // 是否加载 AMapUI，缺省不加载
  AMapUI?: {
    version?: string; // AMapUI 缺省 1.1
    plugins?: string[]; // 需要加载的 AMapUI ui插件
  };
  // 是否加载 Loca， 缺省不加载
  Loca?: {
    version?: string; // Loca 版本，缺省 1.3.2
  };
  securityJsCode: string; // 加载安全防护库
}

export const AMapPlugin = {} as any;

AMapPlugin.install = async function (Vue: any, options: Options) {
  (window as any)._AMapSecurityConfig = {
    securityJsCode: options.securityJsCode,
  };

  try {
    const Amap = await AMapLoader.load({
      version: '2.0',
      ...options,
    });

    Vue.prototype.$AMap = Amap;
  } catch (error) {
    console.error('高德地图加载失败！');
  }
};

export function useAMap() {
  try {
    if (Vue.prototype.$AMap) return Vue.prototype.$AMap;
  } catch (error) {
    console.error('jsapi未预先加载，请先install AMapPlugin！');
  }
}
